import { getLastMonthDateRange } from '~/utils/date';
import { IFormValues } from '../types';

const getInitialValues = (): IFormValues => ({
  ...getLastMonthDateRange(),
});

export default getInitialValues;
